import Screen from "controllers/Screen";
import Easing from "utils/Easing";
import Utils from "utils/Utils";
import Math_ from "utils/Math";
import * as PIXI from 'lib/pixi.js'
import AbstractHeader from "components/partials/interactive-header/js/AbstractHeader";


export default class ServicesHeader extends AbstractHeader {
	constructor($wrapper) {
		super($wrapper);

		this.center = {x: Screen.wW / 4, y: Screen.wH / 6};

		/////// Shapes
		this.duration = 15;
		this.numShapes = 15;

		// Canvas for the shapes
		this.pxShape = null;

		this.init();
	}


	initEl() {

		super.initEl();

		/// First shapes
		for (let i = 0; i < this.numShapes; i++) {
			this.addShape((1 - (1 / this.numShapes)) - (i / this.numShapes));
		}
	}


	raf() {
		super.raf();
		if (this.isVisible) {
			this.drawShapes();
		}
	}

	pause() {
		for (let shapeIndex = 0; shapeIndex < this.shapes.length; shapeIndex++) {
			this.shapes[shapeIndex].pointsTween.map(tween => tween.pause());
			this.shapes[shapeIndex].completionTween.pause();
		}
		super.pause();
	}

	resume() {
		for (let shapeIndex = 0; shapeIndex < this.shapes.length; shapeIndex++) {
			this.shapes[shapeIndex].pointsTween.map(tween => tween.resume());
			this.shapes[shapeIndex].completionTween.resume();
		}
		super.resume();
	}


	resize(isMobileH) {

		if (isMobileH) {
			return;
		}
		
		this.center = {x: Screen.wW / 4, y: Screen.wH / 6};
		super.resize(isMobileH);
	}


	addShape(defaultCompletion) {

		let shape = {},
			numPoints = Math.round(Math.random() * 8 + 4),
			points = [],
			pointsTweens = [],
			completionTween;

		shape.completion = defaultCompletion;

		// 2 . Create all the points
		for (let i = 0; i < numPoints; i++) {

			// 2a . Point default position
			let point = {
				x: (Math.random() / (numPoints)) + (i / (numPoints)),
				y: Math.random(),
				radius: Math.random(),
				angle: (i / (numPoints)) + ((Math.random() - 0.5) / 10)
			};
			points.push(point);
			// Points movement over time
			let pointsTimeline = gsap.timeline(),
				numSteps = Math.round(Math.random() * 4 + 4);
			// numSteps = 4;
			for (let j = 0; j < numSteps; j++) {
				pointsTimeline.to(point, {
					duration: this.duration / numSteps,
					ease: "power1.inOut",
					angle: (i / (numPoints)) + ((Math.random() - 0.5) / 10),
					radius: Math.random()
				});
			}
			pointsTimeline.progress(defaultCompletion);
			pointsTweens.push(pointsTimeline);
		}

		// The y progress of the shape over time
		completionTween = gsap.to(shape, {
			duration: this.duration,
			completion: 1,
			ease: "none",
			onComplete: () => {
				this.killShape(shape);
				this.addShape(0);
			}
		});
		completionTween.progress(defaultCompletion);

		// 5 . Create the shape and add to the collection
		shape.points = points;
		shape.graphics = new PIXI.Graphics();
		shape.pointsTween = pointsTweens;
		shape.completionTween = completionTween;

		// Add child the graphics
		this.pxShape.addChild(shape.graphics);

		// Add to the shapes collection (in first position)
		this.shapes.push(shape);
	}


	drawShapes() {

		// 2 . Loop through the shapes
		for (let shapeIndex = 0; shapeIndex < this.shapes.length; shapeIndex++) {

			const shape = this.shapes[shapeIndex],
				points = [],
				completion = shape.completion,
				scale = completion / 2 * ((this.scrollPercent * 2 + 1)) / this.shapesResolution;

			let xc,
				yc;

			// Loop through all the points in the shape
			for (let pointIndex = 0; pointIndex < shape.points.length; pointIndex++) {
				const tmpPoint = shape.points[pointIndex],
					percent = (1 + tmpPoint.radius),
					radius = Math.hypot(Screen.wW, Screen.wH) * this.shapesResolution * percent,
					// radius = 200 * percent,
					angle = 360 * tmpPoint.angle * this.DEG_TO_RAD;

				points.push(Utils.getPointOnCircle(this.center.x, this.center.y, radius, angle));
			}

			const scrollScale = Easing.easeOutQuart(completion) * this.scrollPercent,
				offsetPosition = (-this.virtualHeight * scrollScale);// Scroll effect;;

			const colorRG = 32 + (Math_.clamp(Easing.easeInQuad(1 - completion) * this.introAlpha * (1 - this.scrollPercent), 0, 1) * (43 - 32)),
				colorB = 32 + (Math_.clamp(Easing.easeInQuad(1 - completion) * this.introAlpha * (1 - this.scrollPercent), 0, 1) * (226 - 32)),
				shapeHex = PIXI.utils.rgb2hex([colorRG / 255, colorRG / 255, colorB / 255]);

			// Shape
			shape.graphics.clear();
			shape.graphics.beginFill(0xFFFFFF);
			shape.graphics.moveTo(points[0].x, points[0].y);
			xc = (points[0].x + points[1].x) / 2;
			yc = (points[0].y + points[1].y) / 2;
			shape.graphics.moveTo(xc, yc);
			for (let i = 1; i < points.length + 1; i++) {
				let a = i % points.length,
					b = (a + 1) % points.length;
				xc = (points[a].x + points[b].x) / 2;
				yc = (points[a].y + points[b].y) / 2;
				shape.graphics.quadraticCurveTo(points[a].x, points[a].y, xc, yc);
			}
			shape.graphics.endFill();
			shape.graphics.pivot.set(this.center.x, this.center.y);
			shape.graphics.position.set(this.center.x, this.center.y + offsetPosition);
			shape.graphics.scale.set(scale, scale);
			shape.graphics.tint = shapeHex;
		}


	}


	killShape(shape) {
		for (let pointIndex = 0; pointIndex < shape.points.length; pointIndex++) {
			shape.points[pointIndex].radiusTw = null;
			shape.points[pointIndex].angleTw = null;
		}
		for (let shapeTweenIndex = 0; shapeTweenIndex < shape.pointsTween.length; shapeTweenIndex++) {
			shape.pointsTween[shapeTweenIndex].kill();
		}
		shape.pointsTween = null;
		shape.graphics.clear();
		shape.graphics.destroy();
		shape.completionTween.kill();
		shape.points = null;
		this.shapes.splice(this.shapes.indexOf(shape), 1);
		shape = null;
	}

}
